export const REPORTS_LOADING = "REPORTS_LOADING";
export const REPORTS_ERROR = "REPORTS_ERROR";

export const REPORTS_GET_LIST = "REPORTS_GET_LIST";
export const REPORTS_GET_LIST_NO_PAGINATION = "REPORTS_GET_LIST_NO_PAGINATION";
export const REPORTS_GET_FILTERS = "REPORTS_GET_FILTERS";



// WEBPACK FOOTER //
// ./src/actions/reports/constants.js